import React, { useEffect, useState } from "react";
import "./WorkflowBasicDetails.scss";
import XetEditor from "../shared/xet-editor/XetEditor";
import { useWorkFlowContext } from "../../context/workflow-context";
import Filter from "../Filter/Filter";
import { FilterOptionSchema } from "../Filter/filter.data";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { useSelector } from "react-redux";
import { userDetails } from "../../redux/user/userSelector";

// interface WorkflowBasicDetailsProps {}

const WorkflowBasicDetails: React.FC = () => {
  const { info, updateInfo } = useWorkFlowContext();
  const [employees, setEmployees] = useState<FilterOptionSchema[]>([]);
  const [forms, setForms] = useState<FilterOptionSchema[]>([]);
  const user = useSelector(userDetails);

  useEffect(() => {
    getEmployees();
  }, []);

  const getEmployees = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.TEAM.GET_EMPLOYEES(user.company_id || -1),
      );
      if (data) {
        setEmployees(data.members);
        setForms(data.forms);
      }
    } catch (e) {
      console.error("Error: ", e);
    }
  };

  const guidelineChangeHandler = (val: string) => {
    updateInfo("guidelines", val);
  };

  const handleDocumentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (event.target.files && event.target.files.length > 0) {
      updateInfo("attachments", Array.from(event.target.files));
      updateInfo("initAttachments", []);
    }
  };

  return (
    <div className="workflow-basic-details-container px-24 py-32 flex-1">
      <div className="details-section p-16 flex-column gap-16">
        <div className="flex-row gap-12">
          <div className="flex-column gap-8 flex-1">
            <p className="xetgo-font-tag bold detail-key">Workflow Name</p>
            <input
              className="detail-input px-12 py-8 xetgo-font-tag"
              placeholder="Enter Name"
              value={info.name}
              onChange={(e) => updateInfo("name", e.target.value)}
            ></input>
          </div>
          <div className="flex-column gap-8 flex-1">
            <p className="xetgo-font-tag bold detail-key">Product Owner</p>
            <Filter
              option={{
                key: "teams",
                name: "Teams",
              }}
              optionList={employees || []}
              multipleSelection={false}
              onSelection={(val, _option) => updateInfo("owner", val[0])}
              preSelected={info.owner ? [info.owner] : []}
              mode="showNames"
              showPlaceholder={true}
              direction="left"
              addNew={false}
              classname="team-filter-input"
            />
          </div>
        </div>
        <div className="flex-column gap-8 flex-1">
          <p className="xetgo-font-tag bold detail-key">Description</p>
          <textarea
            className="detail-input px-12 py-8 xetgo-font-tag"
            placeholder="Enter Description"
            rows={3}
            value={info.description}
            onChange={(e) => updateInfo("description", e.target.value)}
          />
        </div>
        <div className="flex-row gap-12">
          <div className="flex-column gap-8 flex-1">
            <p className="xetgo-font-tag bold detail-key">Attachments</p>
            <div>
              <input
                onChange={handleDocumentUpload}
                id="document-fileInput"
                name="file"
                type="File"
                style={{
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  display: "none",
                }}
                multiple={true}
              />
              <label
                className="input-main-container "
                htmlFor="document-fileInput"
              >
                <p className="detail-input px-12 py-8 flex-row align-items-center cursor-pointer justify-content-space-between xetgo-font-tag">
                  Upload Document
                  <img
                    height={16}
                    width={16}
                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240714075812-upload+%286%29.svg"
                    alt="upload-icon"
                  />
                </p>
              </label>
              <div className="flex-row gap-12">
                {info.initAttachments.map((file, index) => (
                  <div
                    className="xetgo-font-tag file-attachment px-8 py-4 flex-row align-items-center gap-2"
                    key={`file-attach-${index}`}
                  >
                    <img
                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250310105117-paperclip.svg"
                      width={12}
                      height={12}
                    />
                    <p> {file.name}</p>
                  </div>
                ))}
                {info.attachments.map((file, index) => (
                  <div
                    className="xetgo-font-tag file-attachment px-8 py-4"
                    key={`file-attach-${index}`}
                  >
                    <img
                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250310105117-paperclip.svg"
                      width={12}
                      height={12}
                    />
                    <p> {file.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex-column gap-8 flex-1">
            <p className="xetgo-font-tag bold detail-key">Form</p>
            <Filter
              option={{
                key: "form",
                name: "Forms",
              }}
              optionList={forms || []}
              multipleSelection={false}
              onSelection={(val, _option) => updateInfo("form", val[0])}
              preSelected={info.owner ? [info.form] : []}
              mode="showNames"
              showPlaceholder={true}
              direction="left"
              addNew={false}
              classname="team-filter-input"
            />
          </div>
        </div>
        <div className="flex-column gap-8 flex-1">
          <p className="xetgo-font-tag bold detail-key">Guidelines</p>
          <XetEditor
            value={info.guidelines}
            defaultHeight="160px"
            onChange={guidelineChangeHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkflowBasicDetails;
